import React from 'react';
import Breadcrumb from '../components/Breadcrumb';
import FooterOne from '../components/FooterOne';
import NavBar from '../components/NavBar';
import ThankYouDetails from '../components/ThankYouDetails';

const ThankYou = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={'Thank You'} />

      {/* About Area One */}
      <ThankYouDetails />

     

      {/* FAQ Area One */}
      

      

      {/* Counter Area One */}
      

      {/* Contact Area One */}
      

     

      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default ThankYou;
